<template>
    <!-- Main Sidebar Container -->
    <aside class="app-sidebar main-sidebar control-sidebar-light sidebar-custom sidebar-expand">
        <!-- Brand Logo -->
        <!--begin::Sidebar Brand-->
        <div class="sidebar-brand">
            <!--begin::Brand Link-->
            <a href="/" class="brand-link">
                <span class="brand-text fw-light">Đông Tây ERP</span>
            </a>
            <!--end::Brand Link-->
        </div>
        <!--begin::Sidebar Wrapper-->
        <div class="sidebar-wrapper">
            <nav class="mt-2">
                <!--begin::Sidebar Menu-->
                <ul
                    class="nav sidebar-menu flex-column"
                    data-lte-toggle="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item">
                        <a :href=" route('shop_module.dashboard') "
                           :class="route().current('shop_module.dashboard') ? 'active' : ''"
                           class="nav-link"
                        >
                            <i class="nav-icon fa-thin fa-grid-2"></i>
                            <p>Dashboard</p>
                        </a>
                    </li>

                    <li class="nav-header">Sản phẩm</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.product.book')" class="nav-link"
                           :class="route().current('shop_module.product.book') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-list"></i>
                            <p>Danh sách sản phẩm</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.product.transaction')" class="nav-link"
                           :class="route().current('shop_module.product.transaction') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-regular fa-clock-rotate-left"></i>
                            <p>Lịch sử nhập - xuất</p>
                        </a>
                    </li>

                    <li class="nav-header text-uppercase">Nhập hàng</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.good_receipt.create')" class="nav-link"
                           :class="route().current('shop_module.good_receipt.create') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-right-long"></i>
                            <p>Nhập hàng</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.good_receipt.index')" class="nav-link"
                           :class="route().current('shop_module.good_receipt.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-list"></i>
                            <p>DS phiếu nhập</p>
                        </a>
                    </li>

                    <li class="nav-header text-uppercase">Bán lẻ</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.deal.workspace', {ref: 'individual'})" class="nav-link"
                           :class="route().current('shop_module.deal.workspace') && route().params.ref === 'individual' ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-right-long"></i>
                            <p>Bán hàng</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.retail.report')" class="nav-link"
                           :class="route().current('shop_module.retail.report') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-chart-simple"></i>
                            <p>Danh sách phiếu bán lẻ</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.retail.shift-closures.index')" class="nav-link"
                           :class="route().current('shop_module.retail.shift-closures.*')? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-right-long"></i>
                            <p>Phiếu chốt ca</p>
                        </a>
                    </li>
                    <li class="nav-header text-uppercase">Bán buôn</li>
<!--                    <li class="nav-item">-->
<!--                        <a :href="route('shop_module.good_receipt.create')" class="nav-link"-->
<!--                           :class="route().current('shop_module.good_receipt.createxx') ? 'active' : ''"-->
<!--                        >-->
<!--                            <i class="nav-icon fa-duotone fa-solid fa-right-long"></i>-->
<!--                            <p>Luân chuyển nội bộ</p>-->
<!--                        </a>-->
<!--                    </li>-->
                    <li class="nav-item">
                        <a :href="route('shop_module.deal.enterprise')" class="nav-link"
                           :class="route().current('shop_module.deal.enterprise') || route().current('shop_module.deal.enterprise_product_screen') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-right-long"></i>
                            <p>Phiếu xuất bán buôn</p>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a :href="route('shop_module.deal.list')" class="nav-link"
                           :class="route().current('shop_module.deal.list') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-list"></i>
                            <p>DS phiếu xuất</p>
                        </a>
                    </li>

<!--                    <li class="nav-item">-->
<!--                        <a :href="route('shop_module.financial.debts.index')" class="nav-link"-->
<!--                           :class="route().current('shop_module.financial.debts.index') ? 'active' : ''"-->
<!--                        >-->
<!--                            <i class="nav-icon fa-duotone fa-solid fa-list"></i>-->
<!--                            <p>Quản lý công nợ</p>-->
<!--                        </a>-->
<!--                    </li>-->

                    <li class="nav-item">
                        <a :href="route('shop_module.financial.partner_debts.index')" class="nav-link"
                           :class="route().current('shop_module.financial.partner_debts.index') || route().current('shop_module.financial.partner_debts.show') ? 'active' : ''"
                        >
                            <i class="nav-icon fas fa-handshake"></i>
                            <p>Công nợ Đối tác</p>
                        </a>
                    </li>

                    <li class="nav-header text-uppercase">Tài chính</li>

                    <li class="nav-item">
                        <a :href="route('shop_module.financial.receipt_vouchers.index')" class="nav-link"
                           :class="route().current('shop_module.financial.receipt_vouchers.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-file-invoice-dollar"></i>
                            <p>Phiếu thu</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.financial.payment_vouchers.index')" class="nav-link"
                           :class="route().current('shop_module.financial.payment_vouchers.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-file-invoice-dollar"></i>
                            <p>Phiếu chi</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.financial.ledger.index')" class="nav-link"
                           :class="route().current('shop_module.financial.ledger.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-file-invoice-dollar"></i>
                            <p>Sổ tài chính</p>
                        </a>
                    </li>



                    <li class="nav-header text-uppercase">Thưởng Sale</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.financial.sale_commission.estimation')" class="nav-link"
                           :class="route().current('shop_module.financial.sale_commission.estimation') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-chart-line"></i>
                            <p>Ước tính thưởng tháng này</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.financial.sale_commission.index')" class="nav-link"
                           :class="route().current('shop_module.financial.sale_commission.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-trophy"></i>
                            <p>Báo cáo thưởng Sale</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.financial.sale_commission.settings')" class="nav-link"
                           :class="route().current('shop_module.financial.sale_commission.settings') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-cog"></i>
                            <p>Cài đặt thưởng</p>
                        </a>
                    </li>

                    <li class="nav-header text-uppercase">Người giới thiệu</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.referrers.index')" class="nav-link"
                           :class="route().current('shop_module.referrers.index') || route().current('shop_module.referrers.create') || route().current('shop_module.referrers.edit') || route().current('shop_module.referrers.show') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-user-tag"></i>
                            <p>Người giới thiệu</p>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="route('shop_module.referrer_commissions.index')" class="nav-link"
                           :class="route().current('shop_module.referrer_commissions.index') || route().current('shop_module.referrer_commissions.detail') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-hand-holding-dollar"></i>
                            <p>Hoa hồng người giới thiệu</p>
                        </a>
                    </li>

                    <li class="nav-header text-uppercase">Danh mục</li>
                    <li class="nav-item">
                        <a :href="route('shop_module.customer.index')" class="nav-link"
                           :class="route().current('shop_module.customer.index') ? 'active' : ''"
                        >
                            <i class="nav-icon fa-duotone fa-solid fa-users"></i>
                            <p>Đối tác</p>
                        </a>
                    </li>



                    <li class="nav-item">
                        <a :href="route('shop_module.lap_danh_muc.index')" class="nav-link"
                           :class="route().current('shop_module.lap_danh_muc.index') ? 'active' : ''"
                        >
                            <i class="nav-icon far fa-print-search"></i>
                            <p>Lập danh mục</p>
                        </a>
                    </li>




                </ul>
                <!--end::Sidebar Menu-->
            </nav>
        </div>
        <!--end::Sidebar Wrapper-->
    </aside>
</template>

<script setup>

</script>
